export default function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-shape/src/pointRadial.js
// module id = lP1e
// module chunks = 0